<template>
  <div class="container" :data-corp-id="corpId">
    <div class="realWel" v-if="type == 1">
      <router-link class="welAddress-add" :to="{ path: '/address/add' }" v-if="isNullAddress && isNullAddress != null ">新增收货地址</router-link>
      <div class="address_item welAddress_order" v-if="!isNullAddress && isNullAddress != null">
        <!-- <h2>收货信息</h2> -->
          <router-link :to="{ path: '/address' }" >
          <div class="info_wrap">
            <i class="address_icon"></i>
            <div class="address_info_wrap">
              <div class="user_info">
                <div class="name">收货人：{{name}}</div>
                <div class="phone">{{mobile}}</div>
              </div>
                <p class="address_info">{{addressStr}}</p>
              </div>
              <i class="address_right"></i>
            </div>
          </router-link>
      </div>
      <div class="welInfor welAddress">
        <h2>福利信息</h2>
        <div class="shop-infor">
          <div class="shop-inforLeft">
            <img :src="cover"/>
          </div>
          <div class="shop-inforRight">
            <p class="shop-inforDes">{{title}}</p>
            <span class="care_tips">{{catname}}关怀</span>
            <span>数量: 1</span>
          </div>
        </div>
      </div>

      <div class="welRemark">
        <div class="wel-remark">
          <label class="wel-remarks">备注:</label>
          <input class="remarksImfor" type="text" placeholder="请填写备注信息" v-model="mark"/>
        </div>
      </div>
    </div>
    <div class="takeWel" v-if="type == 2">
      <div class="welAddress_take welAddress">
        <h2>自提说明</h2>
        <div class="take-desc" v-html="shippingNote"></div>
      </div>
      <div class="welInfor welAddress">
        <h2>福利信息</h2>
        <div class="shop-infor">
          <div class="shop-inforLeft">
            <img :src="cover"/>
          </div>
          <div class="shop-inforRight">
            <p class="shop-inforDes">{{title}}</p>
            <span>{{catname}}关怀</span>
            <span>数量: 1</span>
          </div>
        </div>
      </div>
    </div>
    <div class="virtualWel" v-if="type == 3">
      <div class="welInfor welAddress">
        <h2>福利信息</h2>
        <div class="shop-infor">
          <div class="shop-inforLeft">
            <img :src="cover"/>
          </div>
          <div class="shop-inforRight">
            <p class="shop-inforDes">{{title}}</p>
            <span>{{catname}}关怀</span>
            <span>数量: 1</span>
          </div>
        </div>
      </div>
    <div class="welRemark" v-if="extensionVirtualCode!='no_require_mobile'">
        <div class="wel-remark">
          <label class="wel-remarks">信息确认：</label>
          
          <input class="remarksImfor" type="text" placeholder="请输入手机号" v-model="confirmMobile"/>
        </div>
        <div class="receive-card">
          方便第一时间接收卡密
        </div>
      </div>
    </div>
    <div class="wel-asure">
        <button class="asureBtn" :disabled="isButtonDisabled" @click="receive" v-if="welfareType==1 &&shippingType ==1">{{buttonText}}</button>
        <button class="asureBtn" :disabled="isButtonDisabled" @click="receiveNoAddressId" v-if="welfareType==1 &&shippingType ==2">{{buttonText}}</button>
        <button class="asureBtn" :disabled="isButtonDisabled" @click="receive" v-if="welfareType==2 &&isReal ==1">{{buttonText}}</button>
        <button class="asureBtn" :disabled="isButtonDisabled" @click="receiveVirtual" v-if="welfareType==2 &&isVirtual ==1">{{buttonText}}</button>
    </div>
    <x-dialog v-model="tipDialog" class="dialog-pop" :scroll="false">
        <div class="content-wrap">
           <p>{{msg}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="tipDialog=false">知道啦</a>
        </div>
      </x-dialog>
      <home :ishome=0></home>
  </div>
</template>
<script>
import aghm from '../../api/aghm.js'
import VueRouter from 'vue-router'
import home from '../common/home.vue'
import  XDialog  from 'vux/src/components/x-dialog/index.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
const router = new VueRouter;
export default {
  data () {
    return {
        tipDialog:false,
        msg:'',


     	  type:0,
        addressId:0,
        addressList:[],
        addressStr:'',
        name:'',
        mobile:'',
        confirmMobile:'',
        isNullAddress:null,
        mark:'',

        goodsId:'',
        goodsVoucherId:'',
        orderGoodsVoucherId:'',
        welfareType:'',
        isReal:'',
        isVirtual:'',
        shippingType:'',
        cover:'',
        title:'',
        catname:'',
        isButtonDisabled:false,
        buttonText:'确认领取',
        extensionVirtualCode:'',

    }
  },
  components:{
    XDialog,
    home
  },
  computed:{
  	 ...mapGetters({
       addressBackUrl:'getaddressBackUrl',
       getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },

  },
  beforeRouteEnter(to, from, next) {
    next(Vm=> {
      if(from.fullPath == '/address' && Vm.addressBackUrl.remarksImfor) {
        Vm.mark = Vm.addressBackUrl.remarksImfor
      } else {
        Vm.mark = ''
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    if(to.fullPath=='/address') {
      let back={
        name:from.name,
        fullPath: from.fullPath,
        remarksImfor: this.mark
      }
      this.$store.dispatch('getAddressBack',back)
    }
    next();
  },
  watch:{},
  beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
    
      this.type = this.$route.query.type;

      this.cover = this.$route.query.cover;
      this.title = this.$route.query.title;
      this.catname = this.$route.query.catname;
      this.goodsId=this.$route.query.goodsId;
      this.goodsVoucherId=this.$route.query.goodsVoucherId;
      this.orderGoodsVoucherId=this.$route.query.orderGoodsVoucherId;
      this.welfareType=this.$route.query.welfareType;
      this.isReal=this.$route.query.isReal;
      this.isVirtual=this.$route.query.isVirtual;
      this.shippingType=this.$route.query.shippingType;
      this.shippingNote = this.$route.query.shippingNote;
        this.extensionVirtualCode =  this.$route.query.extensionVirtualCode

      let _router_addressId = this.$route.query.addressId;


      let _isDefault = false;
      aghm.getUserAddressList().then((res) =>{
          let data = res.data.body;
          if(data.length > 0){
              for(let i=0;i<data.length;i++){
                  if(_router_addressId){
                      if(_router_addressId==data[i].addressId){
                          this.name = data[i].consignee;
                          this.mobile = data[i].mobile;
                          this.addressStr = data[i].province + '  ' + data[i].city + '  ' + data[i].district + '  ' + data[i].address;
                          this.addressId = _router_addressId;
                          _isDefault = true;
                          break;
                      }
                  }else{
                      if(data[i].isDefault == 1){
                          this.name = data[i].consignee;
                          this.mobile = data[i].mobile;
                          this.addressStr = data[i].province + '  ' + data[i].city + '  ' + data[i].district + '  ' + data[i].address;
                          this.addressId = data[i].addressId;
                          _isDefault = true;
                          break;
                      }
                  }
                  
              }
              if(!_isDefault){
                  this.name = data[0].consignee;
                  this.mobile = data[0].mobile;
                  this.addressStr = data[0].province + '  ' + data[0].city + '  ' + data[0].district + '  ' + data[0].address;
                  this.addressId = data[0].addressId;
              }
              this.isNullAddress = false;
          }else{
              this.isNullAddress = true;
          }
      },(error) =>{
          console.log("error");
      })
  },
  methods:{
    receive(){
      let _this = this;
      let _addressId = this.addressId;
      let _goodsId = this.goodsId;
      let _goodsVoucherId = this.goodsVoucherId;
      let _orderGoodsVoucherId = this.orderGoodsVoucherId;
      let _welfareType = this.welfareType;
      let _mark = this.mark;
      this.isButtonDisabled = true;
      this.buttonText = '领取中...';
      if(_addressId==0){
          this.tipDialog = true;
          this.msg = '请选择收货地址';
          _this.buttonText='确认领取';
          _this.isButtonDisabled = false;
          return;
      }
      aghm.receiveReal({
          addressId : _addressId,
          goodsId : _goodsId,
          goodsVoucherId : _goodsVoucherId,
          mark : _mark,
          orderGoodsVoucherId : _orderGoodsVoucherId,
          welfareType : _welfareType
      }).then((res) =>{
          _this.buttonText='确认领取';
          _this.isButtonDisabled = false;
          console.log(res)
        if(res.data.errno){
            this.tipDialog = true;
            this.msg = res.data.error;
        }else{

            router.push({ path: '/welfare/order_success', query: { type: 1 ,oid:res.data.body}})
        }
      },(error) =>{
            this.tipDialog = true;
            this.msg = error;
            _this.buttonText='确认领取';
            _this.isButtonDisabled = false;
      })
    },
    receiveNoAddressId(){
        let _this = this;
        let _goodsId = this.goodsId;
        let _goodsVoucherId = this.goodsVoucherId;
        let _orderGoodsVoucherId = this.orderGoodsVoucherId;
        let _welfareType = this.welfareType;
        let _mark = this.mark;
        this.isButtonDisabled = true;
        this.buttonText = '领取中...';
        aghm.receiveReal({
            goodsId : _goodsId,
            goodsVoucherId : _goodsVoucherId,
            mark : _mark,
            orderGoodsVoucherId : _orderGoodsVoucherId,
            welfareType : _welfareType
        }).then((res) =>{
            _this.isButtonDisabled = false;
            _this.buttonText = '确认领取';
          if(res.data.errno){
              this.tipDialog = true;
              this.msg = res.data.error;
          }else{

              router.push({ path: '/welfare/order_success', query: { type: 1,oid:res.data.body }})
          }
        },(error) =>{
            this.tipDialog = true;
            this.msg = error;
            _this.isButtonDisabled = false;
            _this.buttonText = '确认领取';
        })
    },
    receiveVirtual(){
        let regx_null = /^\s*$/;
        let regx_mobile = /^1\d{10}$/;

        let _this = this;
        let _goodsId = this.goodsId;
        let _goodsVoucherId = this.goodsVoucherId;
        let _orderGoodsVoucherId = this.orderGoodsVoucherId;
        let _welfareType = this.welfareType;
        let _mobile = this.confirmMobile;
        this.isButtonDisabled = true;
        this.buttonText = '领取中...';
        if(this.extensionVirtualCode!='no_require_mobile'){
            if(regx_null.test(_mobile)){
                this.tipDialog = true;
                this.msg = '请输入手机号';
                _this.isButtonDisabled = false;
                _this.buttonText = '确认领取';
                return;
            }
            if(!regx_mobile.test(_mobile)){
                this.tipDialog = true;
                this.msg = '请输入正确的手机号';
                _this.isButtonDisabled = false;
                _this.buttonText = '确认领取';
                return;
            }
        }
        
        aghm.receiveVirtual({
            mobile : _mobile,
            goodsId : _goodsId,
            goodsVoucherId : _goodsVoucherId,
            mobile : _mobile,
            orderGoodsVoucherId : _orderGoodsVoucherId,
        }).then((res) =>{
            _this.isButtonDisabled = false;
            _this.buttonText = '确认领取';
          if(res.data&&res.data.errno){
              this.tipDialog = true;
              this.msg = res.data.error;
          }else{
                router.push({ path: '/welfare/order_success', query: { type: 2,mobile:_mobile,oid:res.data.body,extensionVirtualCode:_this.extensionVirtualCode}})
          }
        },(error) =>{
            _this.isButtonDisabled = false;
            _this.buttonText = '确认领取';
            this.tipDialog = true;
              this.msg = error;
        })
    }
  },
  mounted(){
    this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: '确认商品',
        } 
      })
  }
}
</script>